import React from 'react';
import {useCurrentUser} from 'modules/authentication/provider/hook';
import {RouteNames} from '../../modules/navigation';
import {useTranslation} from '../../modules/i18n';
import {GeoDesktopNav} from './GeoDesktopNav';
import {GeoMobileNav} from './GeoMobileNav';
export interface GeoNavProps {
	isMobile?: boolean;
}

export interface LinkInfo {
	label?: string;
	src: string;
	link?: RouteNames;
}

export const GeoNav: React.FC<GeoNavProps> = ({isMobile}: GeoNavProps) => {
	const {t} = useTranslation();
	const {user} = useCurrentUser();

	const linkDesktop: LinkInfo[] = [
		// {src: 'pictoAccueil', link: 'home', label: t('navbar.home_label')},
		{src: 'pictoRecherche', link: 'search', label: t('navbar.search_label')},
		{
			src: 'pictoTests',
			link: 'test',
			label: t('navbar.test_label')
		},
		{
			src: 'pictoScans',
			link: 'scans',
			label: t('navbar.scan_label')
		},
		{
			src: 'pictoCredits',
			link: 'credits',
			label: t('navbar.credit_label')
		},
		{
			src: 'pictoProfil',
			link: 'profile',
			label: t('navbar.profile')
		}
	];

	if (user?.credit.feasability_quantity > 0) {
		linkDesktop.push({
			src: 'picto-scanFaisabilite',
			link: 'scanFaisa',
			label: t('navbar.scanFaisa_label')
		});
	}
	const linkMobile = [
		{src: 'pictoAccueil', link: 'home', label: t('navbar.home_label')},
		{src: 'pictoRecherche', link: 'search', label: t('navbar.search_label')},
		{
			src: 'pictoTests',
			link: 'test',
			label: t('navbar.test_label')
		},
		{
			src: 'pictoScans',
			link: 'scans',
			label: t('navbar.scan_label')
		},
		{
			src: 'pictoCredits',
			link: 'credits',
			label: t('navbar.credit_label')
		},
		{
			src: 'pictoProfil',
			link: 'profile',
			label: t('navbar.profile')
		}
	];
	return (
		<>
			{isMobile ? (
				<GeoMobileNav listLink={linkMobile} />
			) : (
				<GeoDesktopNav listLink={linkDesktop} />
			)}
		</>
	);
};
